import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../../modules/infra/i18n';

import Modal from '../../../../../../common/Modal';
import Spinner from '../../../../../../common/Spinner';

const DisconnectMailchimp = ({ loadingIsOn, handleDisconnect, openedIsOn, openedOn, openedOff }) => (
  <Fragment>
    <button
      type="button"
      className="c-btn c-btn--medium c-btn--red"
      onClick={openedOn}
    >
      <span className="c-btn__text">{t('settings:integrations.mailchimp.disconnect.button')}</span>
    </button>
    <Modal
      className="mailchimp-modal mailchimp-disconnect"
      display-if={openedIsOn}
      title={t('settings:integrations.mailchimp.disconnect.modal_title')}
      close={openedOff}
      showCloseButton
    >
      <div className="modal-container">
        <div className="modal-container__body">
          <Fragment display-if={!loadingIsOn}>
            {t('settings:integrations.mailchimp.disconnect.confirmation')}
            <p>{t('settings:integrations.mailchimp.disconnect.warning_1')}</p>
            <p>{t('settings:integrations.mailchimp.disconnect.warning_2')}</p>
          </Fragment>

          <Spinner display-if={loadingIsOn} />
        </div>
      </div>
      <div className="modal-controls">
        <button
          type="button"
          className="c-btn c-btn--medium c-btn--grey"
          onClick={openedOff}
        >
          {t('settings:integrations.mailchimp.disconnect.cancel_button')}
        </button>
        <button
          type="button"
          className="c-btn c-btn--medium c-btn--red"
          onClick={handleDisconnect}
        >
          {t('settings:integrations.mailchimp.disconnect.disconnect_button')}
        </button>
      </div>
    </Modal>
  </Fragment>
);
DisconnectMailchimp.propTypes = {
  loadingIsOn: PropTypes.bool.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
  openedOff: PropTypes.func.isRequired,
  openedOn: PropTypes.func.isRequired,
  handleDisconnect: PropTypes.func.isRequired,
};

export default DisconnectMailchimp;
